import React, { useState, useEffect } from "react";
import { Select, Form, Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

function TypSubType({
  form,
  url,
  urlData,
  typName,
  includeAllTyp,
  includeAllSubTyp,
  typLabel,
  typRequired,
  typErrorMessage,
  typPlaceholder,
  subTypName,
  labelCol,
  subTypLabel,
  subTypRequired,
  subTypErrorMessage,
  subTypPlaceholder,
  typDisabled,
  subTypDisabled,
  subTypSearchable,
  typSearchable,
  typDefault,
  subTypDefault,
  subTypMultiSelect
}) {
  const [loginError, setLoginError] = useState(false);
  const [type, setType] = useState([]);
  const [subType, setSubType] = useState([]);
  const [dict, setDict] = useState({});


  const addSubTypData = (data) => {
    if (includeAllSubTyp) {
      setSubType([
        { label: 'All', value: 'all' },
        ...data
      ])
    } else {
      setSubType([
        ...data
      ])
    }
  }

  useEffect(() => {
    let typ = [];
    let localDict = {};
    liracrypt
      .get(url, urlData ? urlData : {})
      .then((res, req) => {
        let allSubTyp = [];
        res.data.data.typSubTypData.forEach((item) => {
          typ.push({ label: item.name, value: item.typ });
          let subTArray = [];
          item.subTyp.forEach((subItem) => {
            allSubTyp.push({ value: subItem._id, label: subItem.name });
            subTArray.push({ value: subItem._id, label: subItem.name });
          });

          localDict[item.typ] = subTArray;
        });
        if (includeAllTyp) {
          localDict['all'] = allSubTyp;
          typ.unshift({ label: 'All', value: 'all' });
        };
        setType(typ);
        setDict(localDict);
        if (typDefault && form) {
          form.setFieldsValue({ [typName]: typDefault });
          if (localDict[typDefault]) {
            addSubTypData(localDict[typDefault]);
            //  setSubType([{ label: 'All', value: 'all' }, ...localDict[typDefault]]);
          }
        }
        if (subTypDefault && form) {
          form.setFieldsValue({ [subTypName]: subTypDefault })
        }

      })
      .catch((err) => {
        console.log(err);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  }, []);

  return (
    <>
      <SessionError visible={loginError} />
      <div>
        <Form.Item
          name={typName}
          labelCol={{ span: labelCol ? labelCol : 8 }}
          label={typLabel}
          style={{ marginRight: "10px", fontWeight: 600 }}
          rules={[
            {
              required: typRequired,
              message: typErrorMessage,
            },
          ]}
        >
          <Select
            onChange={(value) => {
              form.setFieldsValue({ [`${subTypName}`]: undefined });
              if (dict[value]) {
                addSubTypData(dict[value]);
                //  setSubType([{ label: 'All', value: 'all' }, ...dict[value]]);
              }
            }}
            showSearch={typSearchable}
            placeholder={typPlaceholder}
            disabled={typDisabled}
            style={{ fontWeight: 600 }}
          >
            {type.map((item, index) => {
              return (
                <Select.Option
                  value={item.value}
                  key={index}
                  style={{ fontWeight: 600 }}
                >
                  {item.label}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </div>
      {/* </Col>
      <Col> */}
      <Form.Item
        name={subTypName}
        labelCol={{ span: labelCol ? labelCol : 8 }}
        label={subTypLabel}
        style={{ marginRight: "10px", fontWeight: 600 }}
        rules={[
          {
            required: subTypRequired,
            message: subTypErrorMessage,
          },
        ]}
      >
        <Select
          mode={subTypMultiSelect ? "multiple" : undefined}
          style={{ fontWeight: 600 }}
          showSearch={subTypSearchable}
          disabled={subTypDisabled}
          placeholder={subTypPlaceholder}
        >
          {subType.map((item, index) => {
            return (
              <Select.Option
                style={{ fontWeight: 600 }}
                value={item.value}
                key={index}
              >
                {item.label}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
      {/* </Col> */}
    </>
  );
}

export default TypSubType;
